module.exports = __webpack_public_path__ + "img/bg-checkout-drop.3ccccd4c.jpg";